import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LitraMark } from "@/components/Brand";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setToken(res.data.session_token);
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch (e) {
        await refresh();
        navigate("/login");
      }
    })();
  }, [navigate, setUser, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0C0E]">
      <div className="animate-pulse flex flex-col items-center gap-3">
        <LitraMark size={40} />
        <span className="text-[var(--bone-faint)] text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
